import Image from "next/image";
import Link from "next/link";

interface BlogCardProps {
  image: string;
  date: string;
  title: string;
  author: string;
  category: string;
  excerpt: string;
  slug: string;
}

const BlogCard = ({
  image,
  date,
  title,
  author,
  category,
  excerpt,
  slug,
}: BlogCardProps) => {
  return (
    <div data-component-id="src/components/blog/index.tsx:24:4" data-component-path="src/components/blog/index.tsx" data-component-line="24" data-component-file="index.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-white%20border%20rounded-lg%20overflow-hidden%20shadow-sm%20hover%3Ashadow-md%20transition-all%22%7D" className="bg-white border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all">
      <div data-component-id="src/components/blog/index.tsx:25:6" data-component-path="src/components/blog/index.tsx" data-component-line="25" data-component-file="index.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20w-full%20h-64%22%7D" className="relative w-full h-64">
        <Image data-component-id="src/components/blog/index.tsx:26:8" data-component-path="src/components/blog/index.tsx" data-component-line="26" data-component-file="index.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%5Bvar%3Aimage%5D%22%2C%22alt%22%3A%22%5Bvar%3Atitle%5D%22%7D"
          src={image}
          alt={title}
          layout="fill"
          objectFit="contain"
          unoptimized // required for static export
        />
      </div>
      <div data-component-id="src/components/blog/index.tsx:34:6" data-component-path="src/components/blog/index.tsx" data-component-line="34" data-component-file="index.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22p-4%20relative%22%7D" className="p-4 relative">
        <span data-component-id="src/components/blog/index.tsx:35:8" data-component-path="src/components/blog/index.tsx" data-component-line="35" data-component-file="index.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-xs%20text-primaryColor%22%2C%22textContent%22%3A%22%2F%22%7D" className="text-xs text-primaryColor">
          {author} / {category}
        </span>
        <h3 data-component-id="src/components/blog/index.tsx:38:8" data-component-path="src/components/blog/index.tsx" data-component-line="38" data-component-file="index.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22mt-2%20font-semibold%20text-base%22%7D" className="mt-2 font-semibold text-base">{title}</h3>
        <p data-component-id="src/components/blog/index.tsx:39:8" data-component-path="src/components/blog/index.tsx" data-component-line="39" data-component-file="index.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-gray-600%20text-sm%20mt-1%20line-clamp-3%22%7D" className="text-gray-600 text-sm mt-1 line-clamp-3">{excerpt}</p>
        <Link data-component-id="src/components/blog/index.tsx:40:8" data-component-path="src/components/blog/index.tsx" data-component-line="40" data-component-file="index.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22text-primaryColor%20text-sm%20mt-2%20block%20font-medium%22%2C%22textContent%22%3A%22READ%20MORE%22%7D"
          href={`/blog/${slug}`}
          className="text-primaryColor text-sm mt-2 block font-medium"
        >
          READ MORE
        </Link>
        <div data-component-id="src/components/blog/index.tsx:46:8" data-component-path="src/components/blog/index.tsx" data-component-line="46" data-component-file="index.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20top-4%20right-4%20bg-red-600%20text-white%20text-xs%20font-bold%20px-2%20py-1%20rounded%22%7D" className="absolute top-4 right-4 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded">
          {date}
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
